export const isSoftKey = (e: KeyboardEvent) => {
  /*
  * the names of control characters are all currently multiple chars long (e.g., "Escape") and only contain letters and numbers
  * the length of ASCII characters is 1
  * non-ASCII characters contain bytes outside the range of [a-zA-Z]
  * this will support international keyboards
  */
  const key = e?.key

  return e.altKey || e.ctrlKey || e.metaKey || !(key?.length == 1 || (key?.length > 1 && /[^a-zA-Z0-9]/.test(key)));
}
